export default {
	ADD_FEATURES: 'ADD_FEATURES'
};
